import { useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { useFormik } from 'formik';
import * as yup from "yup";
import CloseIcon from '@mui/icons-material/Close';
import BaseButton from "../../BaseButton";
import BaseInput from "../../BaseInput";

import { sendPasswordReset } from "../../../api-services/auth";
import { FIREBASE_AUTH_ERRORS } from "../../../constants/auth-errors";

export default function ResetPasswordModal({ close }) {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isLoading, setIsLoading]= useState(false)
  const [message, setMessage] = useState(null)

  const { errors, handleBlur, handleChange, handleSubmit, touched, values } =
    useFormik({
      validateOnBlur: true,
      initialValues: {
        email: '',
      },
      validationSchema: yup.object({
        email: yup.string()
          .email("Enter a valid email")
          .required("Email is required"),
      }),
      onSubmit: async (values, { setSubmitting }) => {
        setIsLoading(true)
        sendPasswordReset(values.email)
        .then(() => {
          setIsSubmitted(true)
        })
        .catch((error) => {
          setIsSubmitted(false)
          setMessage(FIREBASE_AUTH_ERRORS?.[error.code] || error.message)
          // return showErrorToast({
          //   message: FIREBASE_AUTH_ERRORS?.[error.code] || error.message
          // })
        })
        .finally(() => {
          setIsLoading(false) 
        });         
      },
    });

  return (
    <Box sx={{
      maxWidth: '496px',
      borderRadius: '8px',
      boxShadow: '0px 2px 10px 0px #5B87EF33',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      background: 'white',
      padding: '40px',
      position: 'relative'
    }}>
      <CloseIcon 
        sx={{
          position: 'absolute',
          right: '20px',
          top: '20px',
          color: 'primary.mediumGray',
          fontSize: '32px',
          cursor: 'pointer'
        }}
        onClick={close}
      />
      <form onSubmit={handleSubmit}>
        <Stack
          direction={'column'}
          spacing={'32px'}
        >
          <Typography variant="h2">
            {isSubmitted ? 'Check your email' : 'Forgot password?'}
          </Typography>
          <Typography variant="h4" color='primary.darkGray'>
            {isSubmitted ? 
              'We have sent you a password reset link to your email' : 'Please enter your registered email to receive password reset instructions.'}
          </Typography>
          {!isSubmitted ? (
            <>
            <Box>
              <BaseInput
                fullWidth
                label='Email'
                name='email'
                type='email'
                placeholder='Enter your email'
                value={values.email || ''}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.email ? errors.email : ""}
                error={((touched.email && Boolean(errors.email)) || message)}
                required
              />
              {message && <Typography variant="subText" color="primary.red">{message}</Typography>}
            </Box>
            <Box sx={{
              width: '100%'
            }}>
              <Grid container spacing={'32px'}>
                <Grid item xs={6}>
                  <BaseButton
                    buttonType="default"
                    onClick={close}
                  >
                    Go back
                  </BaseButton>
                </Grid>
                <Grid item xs={6}>
                  <BaseButton
                    buttonType="primary"
                    type='submit'
                    loading={isLoading}
                  >
                    Submit
                  </BaseButton>
                </Grid>
              </Grid>
            </Box>
            </>
          ) : (
            <Box sx={{
              width: '100%'
            }}>
              <Typography variant="body" color="primary.darkGray">Didn't receive email?</Typography>
              <BaseButton
                buttonType="primary"
                sx={{
                  mt: '8px'
                }}
                type="submit"
                loading={isLoading}
              >
                Re-send email
              </BaseButton>
            </Box>
          )}
        </Stack>
      </form>
    </Box>
  )
}